import React from 'react';
import styled from 'styled-components';
import './queryTab.css';

import _ from 'lodash';
import 'react-day-picker/lib/style.css';
import {
  Tabs, Icon, Row, Col, Upload, Radio, Tooltip,
} from 'antd';
import { HelpText } from '../../views/typography';
import VBQLArea from '../../views/VBQLArea';
import Button from '../../views/StyledButton';
import Input from '../../views/InputBouncy';

import ButtonList from '../../views/ButtonList';
import Table from '../../views/StyledTable';
import PartRow from './PartRow';

import QueryTabSelect from './QueryTabSelect';
import QueryTabWhere from './QueryTabWhere';
import QueryTabDateRange from './QueryTabDateRange';
import QueryTabOrder from './QueryTabOrder';
import QueryTabFrom from './QueryTabFrom';
import QueryTabOffset from './QueryTabOffset';
import QueryTabLimit from './QueryTabLimit';
import PendingFieldDialog from './PendingFieldDialog/PendingFieldDialog';
import SaveQuategoryDialog from './QuerySaveDialog/SaveQuategoryDialog';
import MediaDisplay from './MediaDisplay';
import {
  EditContent, EditControls, EditLabel, EditLabelParam, EditMode, EditPane,
  EditPaneHeightControl,
  EditValue, FlexDiv, HiddenNavTabs, NumberField,
} from './queryTabStyle';

const QUERY_LABEL = 'Advanced';
const QUERY_DIV_LABEL = 'Basic';

const { TabPane } = Tabs;

export default ({
  pQuery, pCategory, schema, schemaMenuClick, token,
  queryModel, activeField, chooseActiveField,
  tabKey = 'queryDivided', chooseTab, changeEditMode,
  chooseQuery, chooseQuerySelect, chooseQueryWhere,
  chooseQueryBeforeDate, chooseQueryAfterDate,
  toggleUseBeforeDate, toggleUseAfterDate, addWhereField,
  chooseSelectField, addSelectField,
  uploading, chooseQueryOffset, chooseQueryLimit,
  queryName, doUpdateQueryName, queryOrderBy,
  editingQuery, setEditingQuery, activateObjDialog,
  pendingField, pendingFieldTarget, showPendingFieldDialog, confirmPendingFieldDialog,
  chooseQueryOrderBy, chooseOrderField, addOrderFieldAsc, orderField, addOrderFieldDesc,
  showSaveDialog, saveQuategory, showMedia,
}) => (
  <div>
    <EditPane className="section-edit-query">
      <EditContent>
        {!pCategory ? '' : (
          <HelpText>
            imported from Category &quot;
            {pCategory}
&quot; --
            {' '}
            {pQuery}
          </HelpText>
        )}
        <FlexDiv style={({ display: 'flex' })}>
          <FlexDiv>
            <EditLabel>
              Name
            </EditLabel>
            <Input
              size="small"
              value={queryName}
              onChange={doUpdateQueryName}
              disabled={uploading}
              style={({ width: 200 })}
            />
          </FlexDiv>
          <EditMode>
            <EditLabel>
              Edit Mode
            </EditLabel>
            <Radio.Group
              mid
              compact
              defaultValue={tabKey}
              className="edit-mode"
              onChange={changeEditMode}
              name={tabKey}
            >
              <Radio.Button value="query">Standard</Radio.Button>
              <Radio.Button value="queryDivided">Help Mode</Radio.Button>
            </Radio.Group>
          </EditMode>
        </FlexDiv>
        {!editingQuery && (
        <div className="query-clickable" onClick={() => setEditingQuery(true)}>
          <div style={({ width: '100%', display: 'flex', justifyContent: 'space-between' })}>
            <div className="query-unediting-text">{queryModel.query || '--- empty query; click to edit---'}</div>
          </div>
        </div>
        )}
        {editingQuery ? (
          <HiddenNavTabs
            activeKey={tabKey}
            onChange={chooseTab}
          >
            <TabPane tab={QUERY_LABEL} key="query">
              {tabKey === 'query' && (
              <div className="cm-size-150">
                <VBQLArea
                  value={queryModel.query}
                  onChange={chooseQuery}
                />
              </div>
              )}
            </TabPane>
            <TabPane tab={QUERY_DIV_LABEL} key="queryDivided">
              <Row gutter={24}>
                <Col md={24} xl={18}>
                  <FlexDiv>
                    <EditLabelParam>Select</EditLabelParam>
                    <EditValue>
                      <QueryTabSelect
                        activeField={activeField}
                        chooseSelectField={chooseSelectField}
                        chooseQuerySelect={chooseQuerySelect}
                        addSelectField={addSelectField}
                        tabKey={tabKey}
                        queryModel={queryModel}
                        chooseActiveField={chooseActiveField}
                        schema={schema}
                        schemaMenuClick={schemaMenuClick}
                      />
                    </EditValue>
                  </FlexDiv>

                  <FlexDiv>
                    <EditLabelParam>
Where
                    </EditLabelParam>
                    <EditValue>
                      <QueryTabWhere
                        chooseActiveField={chooseActiveField}
                        activeField={activeField}
                        chooseQueryWhere={chooseQueryWhere}
                        addWhereField={addWhereField}
                        tabKey={tabKey}
                        queryModel={queryModel}
                        schema={schema}
                        schemaMenuClick={schemaMenuClick}
                        toggleUseAfterDate={toggleUseAfterDate}
                        chooseQueryAfterDate={chooseQueryAfterDate}
                        toggleUseBeforeDate={toggleUseBeforeDate}
                        chooseQueryBeforeDate={chooseQueryBeforeDate}
                      />
                    </EditValue>
                  </FlexDiv>

                  <FlexDiv>
                    <EditLabelParam>Order By</EditLabelParam>
                    <EditValue>
                      <QueryTabOrder
                        chooseActiveField={chooseActiveField}
                        chooseQueryOrderBy={chooseQueryOrderBy}
                        activeField={activeField}
                        queryOrderBy={queryOrderBy}
                        tabKey={tabKey}
                        orderField={orderField}
                        chooseOrderField={chooseOrderField}
                        queryModel={queryModel}
                        schema={schema}
                        schemaMenuClick={schemaMenuClick}
                        addOrderFieldAsc={addOrderFieldAsc}
                        addOrderFieldDesc={addOrderFieldDesc}
                      />
                    </EditValue>
                  </FlexDiv>
                </Col>
                <Col md={24} xl={6}>
                  <Row>
                    <Col md={12} xl={24}>
                      <FlexDiv>
                        <EditLabelParam>Offset</EditLabelParam>
                        <NumberField>
                          <QueryTabOffset
                  activeField={activeField}
                  chooseActiveField={chooseActiveField}
                  queryModel={queryModel}
                  chooseQueryOffset={chooseQueryOffset}
                />
                        </NumberField>
                      </FlexDiv>
                    </Col>
                    <Col md={12} xl={24}>
                      <FlexDiv>
                        <EditLabelParam>Limit</EditLabelParam>
                        <NumberField>
                          <QueryTabLimit
                  activeField={activeField}
                  chooseActiveField={chooseActiveField}
                  queryModel={queryModel}
                  chooseQueryLimit={chooseQueryLimit}
                />
                        </NumberField>
                      </FlexDiv>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </TabPane>
          </HiddenNavTabs>
        ) : ''}
      </EditContent>
      <EditControls>
        <Button
          type="primary"
          onClick={() => saveQuategory()}
          block
        >
Save...
        </Button>
      </EditControls>
    </EditPane>
    <MediaDisplay
      token={token}
      query={queryModel.query}
      showMedia={showMedia}
      activateObjDialog={activateObjDialog}
    />
    <PendingFieldDialog {...{
      pendingField,
      pendingFieldTarget,
      token,
      confirmPendingFieldDialog,
      showPendingFieldDialog,
    }}
    />
    {!showSaveDialog ? '' : (
      <SaveQuategoryDialog
        save={saveQuategory}
        query={queryModel.query}
        name={queryName}
        token={token}
        isCategory={!!pCategory}
        showSaveDialog={showSaveDialog}
      />
    )}
  </div>
);

/**
 <FlexDiv>
 <EditLabel>Date Range</EditLabel>
 <EditValue>
 <QueryTabDateRange
 chooseActiveField={chooseActiveField}
 activeField={activeField}
 chooseQueryWhere={chooseQueryWhere}
 addWhereField={addWhereField}
 tabKey={tabKey}
 queryModel={queryModel}
 schema={schema}
 schemaMenuClick={schemaMenuClick}
 toggleUseAfterDate={toggleUseAfterDate}
 chooseQueryAfterDate={chooseQueryAfterDate}
 toggleUseBeforeDate={toggleUseBeforeDate}
 chooseQueryBeforeDate={chooseQueryBeforeDate}
 />
 </EditValue>
 </FlexDiv>
 */
